import React from 'react';
import ReactDOM from 'react-dom';
import Header from './components/Header';
import UBCFooter from './components/UBCFooter';
import '../styles/wordpress.scss';

const headerNode = document.getElementById('cccisd-header');
if (headerNode) {
    ReactDOM.render(<Header className="container-fluid" />, headerNode);
}

const footerNode = document.getElementById('cccisd-footer');
if (footerNode) {
    ReactDOM.render(<UBCFooter />, footerNode);
}
